import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"overflow-x":"auto"} }
const _hoisted_2 = { class: "card-content" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_p_timeline = _resolveComponent("p-timeline")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.enable)
      ? (_openBlock(), _createBlock(_component_p_timeline, {
          key: 0,
          value: _ctx.events,
          align: "bottom",
          layout: "horizontal",
          class: "p-col-12"
        }, {
          marker: _withCtx((slotProps) => [
            _createElementVNode("span", {
              class: "time-event",
              style: _normalizeStyle({ background: _ctx.getBg(slotProps.item) })
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(["pi", _ctx.getIcon(slotProps.item)])
              }, null, 2)
            ], 4)
          ]),
          content: _withCtx((slotProps) => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("p", null, [
                (slotProps.item.dud)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Awaiting "))
                  : _createCommentVNode("", true),
                _createTextVNode(_toDisplayString(slotProps.item.input_event ? "Data Update" : "Review") + " Event", 1)
              ]),
              _createElementVNode("p", null, [
                (slotProps.item.dud)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, "by "))
                  : _createCommentVNode("", true),
                _createTextVNode(" Role: " + _toDisplayString(slotProps.item.role?.split(",")[0]), 1),
                _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
                (slotProps.item.username?.length)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Username: " + _toDisplayString(slotProps.item.username), 1))
                  : _createCommentVNode("", true),
                _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
                (slotProps.item.date)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Date: " + _toDisplayString((new Date(slotProps.item.date)).toLocaleString("en-IN")), 1))
                  : _createCommentVNode("", true)
              ]),
              (slotProps.item.dud)
                ? (_openBlock(), _createElementBlock("small", _hoisted_7))
                : (slotProps.item.approve)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_8, "Approved"))
                  : (slotProps.item.rejected)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_9, "Rejected"))
                    : (!slotProps.item.input_event)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_10, "Need information"))
                      : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["value"]))
      : _createCommentVNode("", true)
  ]))
}